import { RootState } from '../store';
import { SmscStateModel } from './smscStateModel';
import { createSelector } from '@reduxjs/toolkit';
import { smscAdapter } from './smscReducer';
import { convertVersionableIdToString, VersionableId } from '../../types/versionableId';

const selectSmscState = (state: RootState): SmscStateModel => state.smsc;
const selectCommitId = (state: RootState, commitId?: string) => commitId;
const selectVersionableId = (state: RootState, versionableId: VersionableId): string => (
  convertVersionableIdToString(versionableId)
);

export const selectAllSmsc = createSelector(
  selectSmscState,
  smscAdapter.getSelectors().selectAll,
);

export const selectAllSmscByCommitId = createSelector(
  [selectAllSmsc, selectCommitId],
  (smscList, commitId) => {
    return commitId ? smscList.filter(esme => esme.id.commitId === commitId) : [];
  },
);

export const selectSmscByVersionableId = createSelector(
  [selectSmscState, selectVersionableId],
  smscAdapter.getSelectors().selectById,
);

export const selectIsLoadingSmsc = createSelector(
  [selectSmscState],
  state => state.loading,
);

export const selectErrorForSmsc = createSelector(
  selectSmscState,
  state => state.errors,
);
